<div class="flex items-center justify-between h-10">
	<input
		[attr.data-cy]="'ui-select-search'"
		type="text"
		class="border-none text-secondary-800 grow outline-0 w-full placeholder:text-secondary-400"
		[placeholder]="placeholder()"
		[value]="searchText()"
		(input)="onInput($event)"
		(keydown)="onKeyDown($event)"
		#searchInput
	/>
	@if (!searchText()) {
		<ui-icon icon="lens_search" size="m"> </ui-icon>
	} @else {
		<ui-icon size="m" icon="x_cross" (iconClicked)="clearSearch()" class="cursor-pointer">
		</ui-icon>
	}
</div>
